module.exports = __webpack_public_path__ + "static/media/media-it.cb24888d.jpeg";